
export default {
  list: {
  },
};
